import React, { useState } from "react";
import { storage, firestore } from "../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { doc, setDoc, collection, getDocs } from "firebase/firestore";

function UploadForm({ isJanuary }) {
  const [studentName, setStudentName] = useState("");
  const [electricBill, setElectricBill] = useState("");
  const [waterBill, setWaterBill] = useState("");
  const [electricFile, setElectricFile] = useState(null);
  const [waterFile, setWaterFile] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [billsList, setBillsList] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false); // Loading state eklendi

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!electricFile && !waterFile) {
      alert("Lütfen en az bir dosya seçin!");
      return;
    }

    try {
      setLoading(true); // Yükleme başladığında loading true
      if (isJanuary) {
        setMessage("15.02.2025 tarihinde Ocak faturaları alınacaktır.");
      } else {
        const electricStorageRef = ref(
          storage,
          `bills/december/electric/${electricFile.name}`
        );
        const waterStorageRef = ref(
          storage,
          `bills/december/water/${waterFile.name}`
        );

        const electricSnapshot = await uploadBytes(
          electricStorageRef,
          electricFile
        );
        const waterSnapshot = await uploadBytes(waterStorageRef, waterFile);

        const electricFileUrl = await getDownloadURL(electricSnapshot.ref);
        const waterFileUrl = await getDownloadURL(waterSnapshot.ref);

        await setDoc(doc(firestore, "bills", studentName), {
          studentName,
          decemberElectricBill: Number(electricBill),
          decemberWaterBill: Number(waterBill),
          decemberElectricBillUrl: electricFileUrl,
          decemberWaterBillUrl: waterFileUrl,
        });

        alert("Aralık faturası başarıyla yüklendi!");
        setFormSubmitted(true);
        fetchBills(); // Yeni faturaları listeye eklemek için.
        setStudentName("");
        setElectricBill("");
        setWaterBill("");
        setElectricFile(null);
        setWaterFile(null);
      }
    } catch (error) {
      console.error("Hata:", error);
      alert("Bir hata oluştu, lütfen tekrar deneyin.");
    } finally {
      setLoading(false); // Yükleme tamamlandığında loading false
    }
  };

  const fetchBills = async () => {
    try {
      const querySnapshot = await getDocs(collection(firestore, "bills"));
      const bills = [];
      querySnapshot.forEach((doc) => {
        bills.push(doc.data());
      });
      setBillsList(bills);
    } catch (error) {
      console.error("Faturalar alınırken hata oluştu:", error);
    }
  };

  return (
    <div>
      <h2>{isJanuary ? "Ocak Faturası Yükle" : "Aralık Faturası Yükle"}</h2>
      {formSubmitted ? (
        <div>
          <h3>Form başarıyla gönderildi!</h3>
          <p>Faturanız başarıyla yüklendi.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <label>Öğrenci Adı Soyadı:</label>
          <input
            type="text"
            value={studentName}
            onChange={(e) => setStudentName(e.target.value)}
            required
          />
          <label>
            {isJanuary
              ? "Ocak Elektrik Tüketimi (kWh)"
              : "Aralık Elektrik Tüketimi (kWh)"}:
          </label>
          <input
            type="number"
            value={electricBill}
            onChange={(e) => setElectricBill(e.target.value)}
            required
          />
          <label>
            {isJanuary
              ? "Ocak Elektrik Faturası (Resim)"
              : "Aralık Elektrik Faturası (Resim)"}:
          </label>
          <input
            type="file"
            onChange={(e) => setElectricFile(e.target.files[0])}
            required
          />
          <label>
            {isJanuary
              ? "Ocak Su Tüketimi (m³)"
              : "Aralık Su Tüketimi (m³)"}:
          </label>
          <input
            type="number"
            value={waterBill}
            onChange={(e) => setWaterBill(e.target.value)}
            required
          />
          <label>
            {isJanuary
              ? "Ocak Su Faturası (Resim)"
              : "Aralık Su Faturası (Resim)"}:
          </label>
          <input
            type="file"
            onChange={(e) => setWaterFile(e.target.files[0])}
            required
          />
          <button type="submit" disabled={loading}>
            {loading ? "Yükleniyor..." : "Gönder"}
          </button>
        </form>
      )}
      {isJanuary && !formSubmitted && <p>{message}</p>}

      {/* Aralık faturaları listesi */}
      {!isJanuary && billsList.length > 0 && (
        <div>
          <h3>Aralık Faturaları Listesi</h3>
          <table border="1" style={{ width: "100%", textAlign: "center" }}>
            <thead>
              <tr>
                <th>Öğrenci Adı</th>
                <th>Elektrik Tüketimi (kWh)</th>
                <th>Su Tüketimi (m³)</th>
                <th>Elektrik Faturası</th>
                <th>Su Faturası</th>
              </tr>
            </thead>
            <tbody>
              {billsList.map((bill, index) => (
                <tr key={index}>
                  <td>{bill.studentName}</td>
                  <td>{bill.decemberElectricBill}</td>
                  <td>{bill.decemberWaterBill}</td>
                  <td>
                    <a href={bill.decemberElectricBillUrl} target="_blank" rel="noreferrer">
                      Görüntüle
                    </a>
                  </td>
                  <td>
                    <a href={bill.decemberWaterBillUrl} target="_blank" rel="noreferrer">
                      Görüntüle
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default UploadForm;
